import { IconButton } from "@/src/components/buttons";
import { openAudioRecorder } from "../aiAssistant/audioRecorder";
import apiFetch from "@/src/utils/apiFetch";
import {
  FieldAnswer,
  Patient,
  RefAnswer,
  Reference,
} from "@/src/data/allTypes";
import { FaMicrophoneLines } from "react-icons/fa6";
import { getItemId, getUserId } from "@/src/utils/utils";
import { closeDialog, openDialog } from "@/src/components/dialogs";
import Loading from "@/src/components/loading";
import { openToast } from "@/src/utils/toasts";
import { useState } from "react";
import { FieldAnswerAiEdit } from "../aiTasks/AiEditWrapper";

export function AiAudioFormButton({
  patient,
  reference,
  currentFieldAnswers,
  onSuccess,
}: {
  patient: Patient | null | undefined;
  reference: Reference | null | undefined;
  currentFieldAnswers: FieldAnswer[] | null | undefined;
  onSuccess: (
    fieldAnswers: FieldAnswer[],
    edits: Record<string, FieldAnswerAiEdit>
  ) => void;
}) {
  if (!patient || !reference) return null;

  function getNewEdits(newAnswers: (FieldAnswer | null | undefined)[]) {
    let newEdits: Record<
      string,
      {
        fieldId: string;
        oldValue: any;
        newValue: any;
      }
    > = {};
    for (let fieldAnswer of newAnswers) {
      if (!fieldAnswer) continue;
      let fieldId = getItemId(fieldAnswer?.field);
      newEdits[fieldId] = {
        fieldId,
        oldValue: currentFieldAnswers?.find(
          (localFieldAnswer) =>
            getItemId(localFieldAnswer?.field) == getItemId(fieldAnswer?.field)
        )?.value,
        newValue: fieldAnswer?.value,
      };
    }
    return newEdits;
  }

  return (
    <IconButton
      height={40}
      width={40}
      onClick={async () => {
        await openAudioRecorder({
          shouldShowFooter: true,
          onChange: async (transcript, base64Audio) => {
            // const transcript = `La victime a étudié au lycée ne travaille pas et est divorcée depuis 3 ans L'agresseur est son ex mari.
            // Elle a des ecchymoses sur le corps l'agresseur, le certificat a été fait sur réquisition la victime a été frappée avec un couteau,
            // Une itt de 12 jours a été requise.`;

            openDialog({
              id: "extractFieldAnswers",
              title: "Extraction des réponses",
              content: (
                <div className="center p20 c1 gap10">
                  <div className="center">
                    <Loading size={50} />
                  </div>
                  <div className="gray">
                    Extraction des réponses en cours...
                  </div>
                </div>
              ),
            });

            try {
              console.log("the base64Audio", base64Audio);
            
              const fieldAnswers = await apiFetch("ai", "extractFieldAnswers", {
                patient,
                base64Audio,
                currentFieldAnswers,
                userId: getUserId(),
                referenceId: getItemId(reference),
                text: "",
              });
              closeDialog("extractFieldAnswers");
              onSuccess(fieldAnswers, getNewEdits(fieldAnswers));
            } catch (error) {
              closeDialog("extractFieldAnswers");
              console.error(error);
              openToast("error", "Erreur lors de l'extraction des réponses");
            }
          },
        });
      }}
    >
      <FaMicrophoneLines size={25} color="var(--color-primary)" />
    </IconButton>
  );
}
